module.exports = __webpack_public_path__ + "img/head-side-cough-slash.22429a5c.svg";